/* 
 * Connecting to StalkerPortal library
 * Borshchov Dimitriy (grimstal@bigmir.net)
 */

import { typeCheck, checkNumber, checkString, checkFunc, checkArray, isChannelObject } from './type_checker';
import { ChannelObject } from './objects';
import { EpgObject } from './objects';
import $ from "jquery";
import moment from "moment";

export function StalkerParser() {

    this._api_v2_url = "http://v2.api.ott.briz.ua";

    /* response - response from stalker server */
    this.GenresArrayParser = function (response) {
        let genres = response;
        // let IPTV = window.Iptv;

        for (let i = 0; i < genres.length; i++) {
            if (!genres[i].id) {
                continue;
            }

            switch (genres[i].id.toLowerCase()) {
            case 'news':
                genres[i].title = 'Новостные';
                break;
            case 'movies':
                genres[i].title = 'Фильмовые';
                break;
            case 'shows':
                genres[i].title = 'Развлекательные';
                break;
            case 'educations':
                genres[i].title = 'Познавательные';
                break;
            case 'sports':
                genres[i].title = 'Спортивные';
                break;
            case 'childrens':
                genres[i].title = 'Детские';
                break;
            case 'musics':
                genres[i].title = 'Музыкальные';
                break;
            case 'hdtv':
                genres[i].title = 'HDTV';
                break;
            case 'foreign':
            case 'russia':
                genres[i].title = 'Зарубежные';
                break;
            case 'ukraine':
                genres[i].title = 'Украинские';
                break;
            case 'odessa':
                genres[i].title = 'Одесские';
                break;
            case 'specials':
                genres[i].title = 'Опциональные';
                break;
            default:
                break;
            }

        }

        genres.unshift({id: '', title: "Все каналы"});
        genres.push({id: 'favorite', title: "Избранное"});

        return genres;
    };

    this.ChannelsArrayParser = function (data) {

        if (!checkFunc(ChannelObject)) {
            return false;
        }

        let channelsContainer = [];
        let name = null;
        let channelID = null;
        let URL = null;
        let image = null;
        let tvgName = null;
        let groupTitle = null;
        let favorite = null;
        let channel = null;

        if (data.length !== 0) {
            for (let i = 0; i < data.length; i++) {

                name = (data[i].name) ? data[i].name : false;
                channelID = (data[i].id) ? data[i].id : false;
                URL = (data[i].url) ? data[i].url : false;
                image = (data[i].logo) ? this._api_v2_url + data[i].logo : false;
                tvgName = (data[i].id) ? data[i].id : false;
                groupTitle = (data[i].genre_id) ? data[i].genre_id : false;
                favorite = (data[i].favorite) ? data[i].favorite : false;

                if (name && channelID) {
                    channel = new ChannelObject();
                    channel.set({name: name, url: URL, channelID: channelID, image: image, tvgName: tvgName, groupTitle: groupTitle, favorite: favorite});
                    channelsContainer.push(channel);
                }
            }
        } else {
            channel = new ChannelObject();
            channel.set({name: "ПУСТОЙ СПИСОК", url: '0', tvgName: '-'});
            channelsContainer.push(channel);
        }

        return channelsContainer;
    };

    this.EPGArrayParser = function (data, tvgName) {
        if (!data || !checkFunc(EpgObject)) {
            return false;
        }

        let epgArray = [];

        for (let i = 0; i < data.length; i++) {
            if (data[i].start && data[i].end && data[i].name) {
                let epgTemplate = new EpgObject();
                epgTemplate.set(data[i].start, data[i].end, data[i].name, tvgName);
                epgArray.push(epgTemplate);
            }
        }

        return epgArray;
    };

    this.ParseForToday = function () {
        return false;
    };

    this.ParseWithDate = function () {
        return false;
    };

    this.epgFileParser = function () {
        return false;
    };
}


export function M3UParser() {

    /**
     * 
     * @param {type} response
     * @returns {Array|M3UParser.GenreArrayParser.genres|Boolean}
     * 0 - Empty array if nothing found or no or empty response
     * 1 - array of genres
     * 2 - false if ChannelObject not set
     */
    this.GenreArrayParser = function (response) {
        if (typeof (ChannelObject) !== 'function') {
            return false;
        }

        let genres = [];
        let genresArray = [];

        for (let i = 0; i < response.length; i++) {
            let genre = response[i].groupTitle;
            if (genre && $.inArray(genre, genresArray) === -1) {
                genresArray.push(genre);
            }
        }

        for (let n = 0; n < genresArray.length; n++) {
            genres.push({id: genresArray[n], title: genresArray[n]});
        }

        genres.unshift({id: '', title: "Все каналы"});

        return genres;
    };

    this.ChannelsArrayParser = function (data, genre_id) {

        let channelsContainer = [];
        let name;
        let URL;
        let channelID;
        let image;
        let tvgName;
        let groupTitle;
        let favorite;
        let tempContainer = this._M3UParse(data);
        let channel;

        if (tempContainer && tempContainer.length !== 0) {
            for (let i = 0; i < tempContainer.length; i++) {
                name = (tempContainer[i].name) ? tempContainer[i].name.trim() : false;
                URL = (tempContainer[i].URL) ? tempContainer[i].URL.trim() : false;
                channelID = (tempContainer[i].channelID) ? tempContainer[i].channelID.trim() : false;
                image = (tempContainer[i].image) ? tempContainer[i].image.trim() : false;
//               tvgName = (tempContainer[i].tvgName) ? tempContainer[i].tvgName.trim() : false;
                tvgName = "-";
                groupTitle = (tempContainer[i].groupTitle) ? tempContainer[i].groupTitle.trim() : false;
                favorite = false;
                if (name && URL && channelID) {
                    channel = new ChannelObject();
                    if ((genre_id && genre_id === groupTitle) || !genre_id) {
                        channel.set({name: name, url: URL, channelID: channelID, image: image, tvgName: tvgName, groupTitle: groupTitle, favorite: favorite});
                        channelsContainer.push(channel);
                    }
                }
            }
        } else {
            channel = new ChannelObject();
            channel.set({name: "ПУСТОЙ СПИСОК", url: '0', tvgName: '-'});
            channelsContainer.push(channel);
        }
        return channelsContainer;
    };

    this._M3UParse = function (data) {
        if (!checkFunc(ChannelObject)) {
            return false;
        }

        let chanReg = /#EXTINF:-?(\d*).*?(?:\stvg-name="(.*?)")?(?:\sgroup-title="(.*?)")?(?:\stvg-logo="(.*?)")?.*?,([^#\n]*)(?:#EXTGRP:(.*))?/;
        let chanRegGenre = /#EXTGRP:(.+)/;
        let chanRegHTTPStream = /^http:\/\/.*$/;
        let chanRegUDPStream = /^udp:\/\/@.*$/;

        let groupTitle;
        let tempArray = [];
        let cleanArray = [];
        let arr = data.split(/(\n|\r|\n\r|\r\n)/);

        for (let i = 0; i < arr.length; i++) {
            let str = arr[i];
            if (str !== "#EXTM3U" && str.length > 0) {
                if (chanReg.exec(arr[i]) || chanRegHTTPStream.exec(arr[i]) || chanRegUDPStream.exec(arr[i])) {
                    tempArray.push(arr[i]);
                } else if (chanRegGenre.exec(arr[i]) && chanReg.exec(tempArray[tempArray.length - 1])) {
                    tempArray[tempArray.length - 1] += String(arr[i]);
                }
            }
        }

        for (let n = 0; n < tempArray.length; n++) {
            let chanParse = chanReg.exec(tempArray[n]);
            if (chanParse) {
                n++;
                groupTitle = (chanParse[3]) ? chanParse[3].trim() : (chanParse[6]) ? chanParse[6].trim() : '';
                let channel = new ChannelObject();
                channel.set({name: chanParse[5], url: tempArray[n], channelID: chanParse[1], image: chanParse[4], tvgName: chanParse[2], groupTitle: groupTitle});
                cleanArray.push(channel);
            }
        }

        return cleanArray;
    };

    /** Parses the EPG file to get only programms set in channelsContainer
     * WARNING! Also resets the tvgName in channel objects
     * 
     * @param {string} epgFile  -   xmltv file
     * @param {array} channelsContainer -   array of channel objects
     * @returns {Array|Boolean}
     * 0 - array of programms only for channels in channelsContainer array
     * 1 - false if epgFile or channelsContainer not set
     */
    this.epgFileParser = typeCheck(function epgFileParser(epgFile, channelsContainer) {
        if (channelsContainer.length < 1) {
            return false;
        }

        let epgIDArray = [];
        let epgProgrammeArray = [];
        let epgIDTemp = [];
        let epgProgrammeTemp = [];
        let dataArray = [];

        let epgIDObject = {'id': '', 'eng': '', 'rus': '', 'noLang': '', 'icon': ''};
        let chanIDReg = /(?:<channel.*?id\s?=\s?["'](.*?)['"]\s*?>)/;
        let chanEngTitleReg = /(?:<display-name.*?lang\s?=\s?["']en['"]>(.*?)<\/display-name\s*?>)/;
        let chanRusTitleReg = /(?:<display-name.*?lang\s?=\s?["']ru['"]>(.*?)<\/display-name\s*?>)/;
        let chanNoLangReg = /(?:<display-name\s*?>(.*?)<\/display-name\s*?>)/;
        let chanIconReg = /(?:<icon.*?src=["'](.*)['"].*>)/;
        let channelEndReg = /(?:<\/channel>)/;

        let programmeReg = /<programme\s(?:start=["'](\d*)(?:\s(.*))?["'])\s(?:stop=["'](\d*)(?:\s(.*))?["'])\s(?:channel=["'](.*?)["'])>(?:<title.*?>(.*?)<\/title>)?/;
        let titleReg = /<title.*?>(.*?)<\/title>/;

        dataArray = epgFile.split(/(\n|\r|\n\r|\r\n)/);

        for (let i = 0; i < dataArray.length; i++) {
            if (chanIDReg.exec(dataArray[i])) {
                epgIDObject.id = chanIDReg.exec(dataArray[i])[1].trim();
            }
            if (chanEngTitleReg.exec(dataArray[i])) {
                epgIDObject.eng = chanEngTitleReg.exec(dataArray[i])[1].trim();
            }
            if (chanRusTitleReg.exec(dataArray[i])) {
                epgIDObject.rus = chanRusTitleReg.exec(dataArray[i])[1].trim();
            }
            if (chanNoLangReg.exec(dataArray[i])) {
                epgIDObject.noName = chanNoLangReg.exec(dataArray[i])[1].trim();
            }
            if (chanIconReg.exec(dataArray[i])) {
                epgIDObject.icon = chanIconReg.exec(dataArray[i])[1].trim();
            }
            if (channelEndReg.exec(dataArray[i])) {
                if (epgIDObject.id.length > 0) {
                    epgIDTemp.push(epgIDObject);
                }
                epgIDObject = {'id': '', 'eng': '', 'rus': '', 'noLang': '', 'icon': ''};
            }

            if (programmeReg.exec(dataArray[i])) {
                epgProgrammeTemp.push(dataArray[i]);
            }
            if (titleReg.exec(dataArray[i]) && programmeReg.exec(epgProgrammeTemp[epgProgrammeTemp.length - 1])) {
                epgProgrammeTemp[epgProgrammeTemp.length - 1] += dataArray[i];
            }
        }

        for (let l = 0; l < epgIDTemp.length; l++) {
            for (let n = 0; n < channelsContainer.length; n++) {
                if (epgIDTemp[l].eng.toUpperCase() === channelsContainer[n].name.toUpperCase() ||
                        epgIDTemp[l].rus.toUpperCase() === channelsContainer[n].name.toUpperCase() ||
                        epgIDTemp[l].noLang.toUpperCase() === channelsContainer[n].name.toUpperCase()) {
                    epgIDArray.push(epgIDTemp[l]);
                    channelsContainer[n].tvgName = epgIDTemp[l].id;
                }
            }
        }

        for (let p = 0; p < epgProgrammeTemp.length; p++) {
            let regResult = programmeReg.exec(epgProgrammeTemp[p]);
            let inArray = false;
            let tempTime;
            let timeZone;
            let startTime;
            let endTime;

            if (regResult) {
                if (!regResult[5]) {
                    continue;
                } else {
                    for (let m = 0; m < epgIDArray.length; m++) {
                        if (regResult[5] === epgIDArray[m].id) {
                            inArray = true;
                            break;
                        }
                    }
                    if (!inArray) {
                        continue;
                    }
                }

                if (regResult[1]) {
                    tempTime = String(regResult[1]);
                    startTime = tempTime.substr(0, 4) + "-" + tempTime.substr(4, 2) + "-" + tempTime.substr(6, 2) + " " +
                            tempTime.substr(8, 2) + ":" + tempTime.substr(10, 2) + ":" + tempTime.substr(12, 2);
                    if (regResult[2]) {
                        timeZone = String(regResult[2]);
                        startTime += '' + timeZone.substr(0, 3) + ':' + timeZone.substr(3, 2);
                    } else {
                        startTime += 'Z';
                    }
                    startTime = moment(startTime).unix();
                }

                if (regResult[3]) {
                    tempTime = String(regResult[3]);
                    endTime = tempTime.substr(0, 4) + "-" + tempTime.substr(4, 2) + "-" + tempTime.substr(6, 2) + " " +
                            tempTime.substr(8, 2) + ":" + tempTime.substr(10, 2) + ":" + tempTime.substr(12, 2);
                    if (regResult[4]) {
                        timeZone = String(regResult[4]);
                        endTime += '' + timeZone.substr(0, 3) + ':' + timeZone.substr(3, 2);
                    } else {
                        endTime += 'Z';
                    }
                    endTime = moment(endTime).unix();
                }

                if (startTime && endTime) {
                    let epgTemplate = new EpgObject();
                    epgTemplate.set(startTime, endTime, regResult[6], regResult[5]);
                    epgProgrammeArray.push(epgTemplate);
                }
            }
        }
        return epgProgrammeArray;
    }, [checkString, checkArray]);

    /** Returns all epg for selected channel
     * 
     * @param {Array} epgProgrammeArray -   array of epg programms
     * @param {Object} channelObj   -   channel for getting his epg
     * @returns {Array|M3UParser.EPGArrayParser.epgArray|Boolean}
     * 0 - empty array if no programms found
     * 1 - array of programms for selected channel
     * 2 - false if epgProgrammeArray or channelObj not set
     */
    this.EPGArrayParser = typeCheck(function EPGArrayParser(epgProgrammeArray, channelObj) {
        let epgArray = [];

        for (let i = 0; i < epgProgrammeArray.length; i++) {
            if (epgProgrammeArray[i].tvgName === channelObj.tvgName) {
                epgArray.push(epgProgrammeArray[i]);
                $('#parsingListener').trigger('progressEPGParsing', [i + 1, epgProgrammeArray.length]);
            }
        }

        return epgArray;
    }, [checkArray, isChannelObject]);

    /**  
     * @param {array} epgArray  -   array of programms for selected channel
     * @param {?number} amount  -   amount of programms would be returned
     * @returns {Array|M3UParser.ParseForToday.cleanArray|Boolean} -
     *  0 - Empty array if no programms found || 
     *  1 - Selected amount of programms that will be played including current
     *  or all programms for today from current playing if amount no set
     *  2 - False if epgArray not set
     */
    this.ParseForToday = typeCheck(function ParseForToday(epgArray, amount) {
        function sorter(a, b) {
            return a.startTime - b.startTime;
        }

        let IPTV = window.Iptv;
        let amountReg = /[0-9]+/;
        let counter = 0;
        let cleanArray = [];
        let now = moment().unix();
        let today = moment().startOf('day').unix();
        let tomorrow = moment().add(1, 'days').startOf('day').unix();
        let checker = false;
        let epgTemplate;

        if (!checkFunc(EpgObject)) {
            return false;
        }

        if (epgArray.length > 0) {
            let sortedArray = epgArray.sort(sorter);

            for (let i = 0; i < sortedArray.length; i++) {
                $('#parsingListener').trigger('progressEPGParsing', [i + 1, sortedArray.length]);
                if (amount && amountReg.exec(amount)) {
                    if (counter < amount) {
                        if ((sortedArray[i].startTime < now && sortedArray[i].endTime >= now) ||
                                (sortedArray[i].startTime > now)) {
                            cleanArray.push(sortedArray[i]);
                            counter++;
                        }
                    }
                } else {
                    if (((sortedArray[i].startTime < now && sortedArray[i].endTime >= now) ||
                            sortedArray[i].startTime > now) && sortedArray[i].startTime < tomorrow) {
                        cleanArray.push(sortedArray[i]);
                    }
                }
            }

            if (cleanArray.length > 0) {
                for (let n = 0; n < cleanArray.length; n++) {
                    if (cleanArray[n].startTime < now && cleanArray[n].endTime >= now) {
                        checker = true;
                    }
                }

                if (checker === false) {
                    epgTemplate = new EpgObject();
                    epgTemplate.set(today, cleanArray[0].startTime, IPTV.getTranslation("epg_is_empty"), cleanArray[0].tvgName);
                    cleanArray.unshift(epgTemplate);
                    if (cleanArray.length > amount) {
                        cleanArray.pop();
                    }
                }
            }

        }
        return cleanArray;
    }, [checkArray, checkNumber]);

    /** 
     * @param {type} epgArray
     * @param {number} startTime  -   unixTimestamp, start of date
     * @param {number} endTime - unixTimestamp, end of date
     * @returns {Array|M3UParser.ParseWithDate.cleanArray|Boolean}
     * 0 - Empty array if no programms found 
     * 1 - Array of programms for selected time range
     * 2 - False if epgArray or time range not set
     */
    this.ParseWithDate = typeCheck(function ParseWithDate(epgArray, startTime, endTime) {
        function sorter(a, b) {
            return a.startTime - b.startTime;
        }

        if (!checkFunc(EpgObject)) {
            return false;
        }

        let cleanArray = [];

        if (epgArray.length > 0) {
            let sortedArray = epgArray.sort(sorter);
            for (let i = 0; i < sortedArray.length; i++) {
                if (sortedArray[i].startTime >= startTime && sortedArray[i].startTime < endTime) {
                    cleanArray.push(sortedArray[i]);
                }
            }
        }

        return cleanArray;
    }, [checkArray, checkNumber, checkNumber]);
}


// WEBPACK FOOTER //
// ./src/api/parsers.js